var _style, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconQuotations(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t {fill:#050505;}\r\n\t.st1{opacity:0.5;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M18.4,23H5.6c-1.6,0-2.9-1.3-2.9-2.9V3.9C2.8,2.3,4.1,1,5.6,1h9.8c0.6,0,1.3,0.2,1.8,0.6l2.9,2.3 c0.7,0.5,1.1,1.4,1.1,2.3v14C21.2,21.7,20,23,18.4,23z M5.6,3C5.2,3,4.8,3.4,4.8,3.9v16.2c0,0.5,0.4,0.9,0.9,0.9h12.7 c0.5,0,0.9-0.4,0.9-0.9v-14c0-0.3-0.1-0.5-0.3-0.7L16,3.2C15.8,3.1,15.6,3,15.4,3H5.6z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M17,9.3h-3.2c-0.6,0-1-0.4-1-1V5.1c0-0.6,0.4-1,1-1s1,0.4,1,1v2.2H17c0.6,0,1,0.4,1,1S17.5,9.3,17,9.3z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQuotations);
export default __webpack_public_path__ + "static/media/icon-quotations.b3d14cb79dc2f81be4ae619ed7d1c0be.svg";
export { ForwardRef as ReactComponent };